import React from 'react'
import { Clock, BookMarked, Layout, FileText } from 'lucide-react'
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll'

const BENEFITS = [
  {
    icon: Clock,
    title: 'Seu tempo de volta',
    description: 'A prova que tomava a tarde inteira sai em minutos. O café ainda quente.',
  },
  {
    icon: BookMarked,
    title: 'Banco curado de verdade',
    description: '729+ subtópicos revisados por professores, alinhados à BNCC. Nada de caçar questão em PDF antigo.',
  },
  {
    icon: Layout,
    title: 'Templates com cara de livro',
    description: 'Cabeçalho, numeração e gabarito diagramados. Sua prova parece saída de editora.',
  },
  {
    icon: FileText,
    title: 'PDF que imprime certo',
    description: 'A4 ou Carta, retrato ou paisagem, margens ajustáveis. Funciona em qualquer impressora da escola.',
  },
]

const BeneficiosSection: React.FC = () => {
  const revealRef = useRevealOnScroll<HTMLDivElement>()

  return (
    <section
      id="beneficios"
      className="py-20 bg-surface dark:bg-ink-900"
      aria-labelledby="beneficios-titulo"
    >
      <div ref={revealRef} className="container mx-auto px-4">
        <div data-reveal-item className="text-center mb-16">
          <p className="flex items-center justify-center gap-3 font-mono text-caderno-xs uppercase tracking-widest text-ink-400 dark:text-ink-300 mb-4">
            <span className="text-terra-500">04</span>
            <span aria-hidden="true" className="w-8 h-px bg-cream-400 dark:bg-ink-500" />
            Por que funciona
          </p>
          <h2
            id="beneficios-titulo"
            className="text-3xl md:text-4xl font-display text-ink-900 dark:text-cream-50 mb-4"
          >
            Menos madrugada. <span className="italic font-normal text-terra-500">Mais aula.</span>
          </h2>
          <p className="text-xl text-ink-500 dark:text-cream-300 max-w-3xl mx-auto">
            Quatro coisas que devolvem o seu fim de semana.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon
            return (
              <div
                key={b.title}
                data-reveal-item
                className={`${i > 0 ? `reveal-delay-${i} ` : ''}bg-cream-50 dark:bg-ink-700 rounded-caderno-sm border border-cream-400 dark:border-ink-500 p-6 shadow-caderno-sm hover:shadow-caderno-lg transition-all duration-300`}
              >
                <div className="w-14 h-14 bg-terra-100 dark:bg-terra-500/30 rounded-caderno-xs flex items-center justify-center mb-6">
                  <Icon className="w-7 h-7 text-terra-500 dark:text-terra-300" aria-hidden="true" />
                </div>
                <h3 className="text-xl font-display text-ink-900 dark:text-cream-50 mb-3">{b.title}</h3>
                <p className="text-ink-500 dark:text-cream-300">{b.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default BeneficiosSection
